import { _ as _extends } from '../../../extends-30811c5e.js';
import { _ as _objectWithoutProperties } from '../../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';
import { getPrefixCls } from '../../../utils/getPrefix.js';
import { Modal } from '../ModalBase.js';
import '../../../defineProperty-6f298737.js';
import 'react-dom';
import '../../Icon/IconCrossSmall.js';

var _excluded = ["illustration", "headline", "description", "actions"];
var prefixCls = getPrefixCls('modal');
var renderIllustration = function renderIllustration(illustration, title) {
  if (illustration) {
    return typeof illustration === 'string' ? /*#__PURE__*/React__default.createElement("img", {
      className: "".concat(prefixCls, "_illustration"),
      src: illustration,
      alt: title
    }) : /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(prefixCls, "_illustration")
    }, illustration);
  }
  return null;
};
function Default(_ref) {
  var illustration = _ref.illustration,
    headline = _ref.headline,
    description = _ref.description,
    actions = _ref.actions,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Modal, _extends({}, props, {
    className: classNames("".concat(prefixCls, "-default"), props.className)
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_body")
  }, illustration && renderIllustration(illustration, headline), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_headline")
  }, headline), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_description")
  }, description)), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_actions")
  }, actions));
}

export { Default };
